/**
 * 销售代表主数据路由
 * Sales Representative Master Data Routes
 */

import { RouterView } from 'vue-router';

const RepresentativeRoutes = {
  path: '/master-data',
  component: RouterView,
  meta: {
    title: '主数据管理',
    icon: 'database',
    order: 5
  },
  children: [
    {
      path: '/master-data/representative',
      name: 'RepresentativeList',
      component: () => import('@/views/master-data/representative/index'),
      meta: {
        title: '销售代表管理',
        icon: 'user',
        keepAlive: true
      }
    },
    {
      path: '/master-data/representative/detail/:id',
      name: 'RepresentativeDetail',
      component: () => import('@/views/master-data/representative/detail'),
      meta: {
        title: '销售代表详情',
        icon: 'profile',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    },
    {
      path: '/master-data/representative/create',
      name: 'RepresentativeCreate',
      component: () => import('@/views/master-data/representative/create'),
      meta: {
        title: '新建销售代表',
        icon: 'user-add',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    },
    {
      path: '/master-data/representative/edit/:id',
      name: 'RepresentativeEdit',
      component: () => import('@/views/master-data/representative/edit'),
      meta: {
        title: '编辑销售代表',
        icon: 'edit',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    },
    {
      path: '/master-data/representative/:id/organization',
      name: 'RepresentativeOrganization',
      component: () => import('@/views/master-data/representative/organization'),
      meta: {
        title: '组织归属管理',
        icon: 'apartment',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    },
    {
      path: '/master-data/representative/:id/customer',
      name: 'RepresentativeCustomer',
      component: () => import('@/views/master-data/representative/customer'),
      meta: {
        title: '客户分配管理',
        icon: 'team',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    },
    {
      path: '/master-data/representative/:id/region',
      name: 'RepresentativeRegion',
      component: () => import('@/views/master-data/representative/region'),
      meta: {
        title: '区域覆盖管理',
        icon: 'environment',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    },
    {
      path: '/master-data/representative/:id/qualification',
      name: 'RepresentativeQualification',
      component: () => import('@/views/master-data/representative/qualification'),
      meta: {
        title: '资质证书管理',
        icon: 'safety-certificate',
        activeMenu: '/master-data/representative',
        hideInMenu: true
      }
    }
  ]
};

export default RepresentativeRoutes;
